// removed by extract-text-webpack-plugin
module.exports = {"photoBanner":"_1e9J","img":"_3ShH","fade":"_1gPR","slider":"_20gZ","photoCounter":"_3DjR","dotnav":"_3f0n","activeDot":"_11WN","inactiveDot":"_3SIF","slideshow":"_1UC6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pagescreen/photobanner/style.css
// module id = 413
// module chunks = 9